import { RootState } from 'src/state/types';

import { AuthState } from './types';

export const selectAuthState = (state: RootState): AuthState => state.auth;
